import React, {PropsWithChildren, useId} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {InfoCircle} from "react-bootstrap-icons";
import styles from './InfoTooltip.module.scss';


export default function InfoTooltip({ children }: PropsWithChildren<{}>) {
    const id = useId();

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={(props) => <Tooltip id={id} {...props}>{children}</Tooltip>}
            defaultShow={false}
        >
            <InfoCircle className={styles.InfoTooltip} />
        </OverlayTrigger>
    );
}
